import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment-timezone';
import Paginator from '../../components/Paginator';
import { toSortOrder, parse, sortUrl } from '../../utils/UrlUtil';
import JobProfileListHeader from './JobProfileListHeader';

const messages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'name' },
  template: { id: 'attrs.assessmentTemplate', defaultMessage: 'Assessment Template' },
  created: { id: 'attrs.created', defaultMessage: 'Created' },
  updated: { id: 'attrs.updated', defaultMessage: 'Updated' },
  jps: { id: 'JPS.short', defaultMessage: 'JPS' },
});

const getJPSLink = (jpsInfo, jobId, currentAccount) => {
  const jpsListLink = `/accounts/${currentAccount}/job-profiles/${jobId}/surveys`;
  return (
    <Link to={jpsListLink}>
      <span
        className={`clickable filter is-active${
          jpsInfo.submittedJps === jpsInfo.totalJps ? ' filter--success' : ' filter--warning'
        }`}
      >
        {jpsInfo.submittedJps}
        {' '}
/
        {jpsInfo.totalJps}
      </span>
    </Link>
  );
};

const nameTemplate = (rowData, { currentAccount, keyField, displayField }) => {
  const detailUrl = `/accounts/${currentAccount}/job-profiles/${rowData[keyField]}`;
  return (
    <Link to={detailUrl} className="app-link">
      {rowData[displayField]}
    </Link>
  );
};

const timeFieldTemplate = (rowData, { formatDate, field }) => {
  const updated = formatDate(moment(rowData[field]), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return updated;
};

class JobProfileList extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      connection: {
        edges, totalCount, indexFrom, indexTo, pageInfo,
      },
      intl: { formatMessage, formatDate },
      currentAccount,
      loading,
      location,
    } = this.props;

    // data list
    const listRows = edges.map(({ node }) => ({
      ...node,
      template: node.assessmentTemplate.title,
      jpsInfo: getJPSLink(node.jpsInfo, node.id, currentAccount),
    }));

    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;

    // header
    const nameHeader = formatMessage(messages.name);
    const templateHeader = formatMessage(messages.template);
    const createdHeader = formatMessage(messages.created);
    const updatedHeader = formatMessage(messages.updated);
    const jpsHeader = formatMessage(messages.jps);

    // footer
    const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Panel>
              <div className="p-grid">
                <div className="p-col-12">
                  <JobProfileListHeader />
                </div>
                <div className="p-col-12 align-center">
                  <DataTable
                    value={listRows}
                    responsive
                    sortField={sortBy}
                    sortOrder={toSortOrder(sortDir)}
                    onSort={this.onSortChange}
                    lazy
                    loading={loading}
                    autoLayout
                  >
                    <Column
                      field="name"
                      header={nameHeader}
                      currentAccount={currentAccount}
                      body={nameTemplate}
                      keyField="id"
                      displayField="name"
                      sortable
                      style={{ textAlign: 'left' }}
                    />
                    <Column
                      field="template"
                      header={templateHeader}
                      sortable
                    />
                    <Column
                      field="createdOn"
                      header={createdHeader}
                      body={timeFieldTemplate}
                      formatDate={formatDate}
                      sortable
                    />
                    <Column
                      field="updatedOn"
                      header={updatedHeader}
                      body={timeFieldTemplate}
                      formatDate={formatDate}
                      sortable
                    />
                    <Column field="jpsInfo" header={jpsHeader} />
                  </DataTable>
                </div>
                <div className="p-col-12 align-center">{footer}</div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

JobProfileList.propTypes = {
  connection: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(injectIntl(JobProfileList));
